
import React, {FC} from 'react';
import {SchedulerModal} from 'components/Assistant/_Scheduler/SchedulerModal';
import Button from 'components/Button';
import HrWithText from 'components/HrWithText';
import {useToggle} from 'hooks/useToggle';

import ChatIcon from './svgs/chat.inline.svg';

type AssistantProps = {
	hr?: boolean
}

export const Assistant: FC<AssistantProps> = ({hr}) => {
	const {open, toggle} = useToggle(false);
	return (
		<>
			{hr && <HrWithText>or</HrWithText>}
			<Button variant='gr-bluegreen' onClick={toggle}>
				<ChatIcon />
				Try our AI booking agent
			</Button>
			{open && (
				<SchedulerModal onHide={toggle} />
			)}
		</>
	);
};
